export const OTHER_NEWS_MENU_OPTIONS = [
  {
    title: 'देश-विदेश',
    submenus: [
      { label: 'ब्रेकिंग न्यूज़', link: '/breaking-news' }
    ]
  },
  {
    title: 'उत्तर प्रदेश',
    submenus: [
      { label: 'बड़ी खबर', link: '/up-news' }
    ]
  },
  {
    title: 'राजनीति',
    submenus: [
      { label: 'संग्राम', link: '/politics' }
    ]
  },
  {
    title: 'शिक्षा',
    submenus: [
      { label: 'जागरूकता', link: '/education' }
    ]
  },
  {
    title: 'धर्म',
    submenus: [
      { label: 'सनातन', link: '/raashi' },
      { label: 'सुविचार', link: '/suvichar' }
    ]
  },
  {
    title: 'मनोरंजन',
    submenus: [
      { label: 'बैंड-बाजा', link: '/entertainment' }
    ]
  },
  {
    title: 'इतिहास',
    submenus: [
      { label: 'ज्ञानी बाबा', link: '/history' }
    ]
  }
];

export const PUBLIC_OTHER_NEWS_PAGES = {
  '/breaking-news': {
    menuTitle: 'देश-विदेश',
    submenu: 'ब्रेकिंग न्यूज़',
    pageTitle: 'ब्रेकिंग न्यूज़',
    subtitle: 'देश और विदेश की ताजा खबरें',
    emoji: '🔥'
  },
  '/up-news': {
    menuTitle: 'उत्तर प्रदेश',
    submenu: 'बड़ी खबर',
    pageTitle: 'उत्तर प्रदेश',
    subtitle: 'प्रदेश की बड़ी और जरूरी खबरें',
    emoji: '🏛️'
  },
  '/politics': {
    menuTitle: 'राजनीति',
    submenu: 'संग्राम',
    pageTitle: 'राजनीति',
    subtitle: 'राजनीतिक घटनाओं की प्रमुख कवरेज',
    emoji: '🗳️'
  },
  '/education': {
    menuTitle: 'शिक्षा',
    submenu: 'जागरूकता',
    pageTitle: 'शिक्षा',
    subtitle: 'शिक्षा जगत की नई जानकारी और अपडेट',
    emoji: '📚'
  },
  '/raashi': {
    menuTitle: 'धर्म',
    submenu: 'सनातन',
    pageTitle: 'सनातन',
    subtitle: 'धर्म और परंपरा से जुड़ी खबरें',
    emoji: '🙏'
  },
  '/suvichar': {
    menuTitle: 'धर्म',
    submenu: 'सुविचार',
    pageTitle: 'सुविचार',
    subtitle: 'प्रेरक और धार्मिक विचार',
    emoji: '🪔'
  },
  '/entertainment': {
    menuTitle: 'मनोरंजन',
    submenu: 'बैंड-बाजा',
    pageTitle: 'मनोरंजन',
    subtitle: 'फिल्म, संगीत और मनोरंजन की खबरें',
    emoji: '🎬'
  },
  '/history': {
    menuTitle: 'इतिहास',
    submenu: 'ज्ञानी बाबा',
    pageTitle: 'इतिहास',
    subtitle: 'इतिहास और विरासत से जुड़ी कहानियां',
    emoji: '📖'
  }
};

export function getSubmenusForTitle(menuTitle) {
  return OTHER_NEWS_MENU_OPTIONS.find((item) => item.title === menuTitle)?.submenus || [];
}
